import { render, staticRenderFns } from "./VAside.vue?vue&type=template&id=901e4e54&"
import script from "./VAside.vue?vue&type=script&lang=js&"
export * from "./VAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports